// src/components/common/LottieSpinner.js
import Lottie from "lottie-react";
import React from "react";

import animationData from "../../assets/animations/trail-loading.json";

const LottieSpinner = () => {
    return (
        <div className="fixed inset-0 z-[9999] bg-white bg-opacity-90 flex flex-col items-center justify-center">
            <Lottie
                animationData={animationData}
                loop={true}
                className="w-48 h-48"
            />
        </div>
    );
};

export default LottieSpinner;
